<template>
  <div class="test-component">
    <h1>Vue 3 Test Component</h1>
    <p>
      This is a simple test component to verify that Vue 3 is working correctly.
    </p>
    <v-btn color="primary" @click="increment"> Count: {{ count }} </v-btn>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  name: "TestComponent",
  setup() {
    const count = ref(0);

    const increment = () => {
      count.value++;
    };

    return {
      count,
      increment,
    };
  },
};
</script>

<style>
.test-component {
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
}
</style>
